import { FC, useState, useEffect } from 'react';

import {useIntl} from 'react-intl'

import {Modal} from '../../../components/Modal'

import {useFormik} from 'formik'

import { chatMessageAPI } from '../../../api'

import {FEEDBACK_CATEGORIES, FEEDBACK_CATEGORIES_FOR_ATTRIBUTION, FEEDBACK_CATEGORIES_FOR_IMAGE} from '../../../models'

interface Props {
  chatId: string
  chatMessageId: number
  type: string
  attributionId?: string
  fileId?: number
  show: boolean
  handleClose: () => void
}


interface FeedbackFormValues {
  feedback: string;
  feedback_categories: string[];
  attribution_id?: string;
  file_id?: number;
  type?: string;
}

const getCategories = (type: string) => {
  if (type == 'image'){
    return FEEDBACK_CATEGORIES_FOR_IMAGE
  }else if (type == 'attribution'){
    return FEEDBACK_CATEGORIES_FOR_ATTRIBUTION
  }else{
    return FEEDBACK_CATEGORIES
  }
}

const ChatResponseFeedbackModal: FC<Props> = ({ chatId, chatMessageId, type, attributionId, fileId, show, handleClose }) => {
  
  const intl = useIntl()

  const [handling, setHandling] = useState(false)

  const CATEGORIES = getCategories(type)

  const formik = useFormik<FeedbackFormValues>({  
    initialValues: { feedback: '', feedback_categories: [], attribution_id: attributionId, type: type, file_id: fileId },  
    onSubmit: (values) => {  
      if( chatMessageId ){
        setHandling(true)
        values['feedback_category'] = values.feedback_categories.join(', ')
        chatMessageAPI.submitFeedback(chatId, chatMessageId, values).then(() => {
          handleClose()
        }).finally (() => {
          setHandling(false)
        })
      }
    },  
  });  

  useEffect(() => {
    if (show) {
      formik.resetForm()
    }
  }, [show])

  const handleCategoryChange = (category: string) => {
    const selectedCategories = formik.values.feedback_categories.includes(category)
      ? formik.values.feedback_categories.filter(item => item !== category)
      : [...formik.values.feedback_categories, category];
    formik.setFieldValue('feedback_categories', selectedCategories);
  };

  return <Modal
      dialogClassName='modal-dialog modal-dialog-centered w-lg-500px'
      show={show}
      handleClose={handleClose}
      title={intl.formatMessage({id: 'chat.message.feedback.title'})}
    >
    <form
      className='form fv-plugins-bootstrap5 fv-plugins-framework'
      onSubmit={formik.handleSubmit}
      noValidate
    >
      <div className="mb-5 fv-row fv-plugins-icon-container">
        <div>
          {CATEGORIES.map((category, index) => (
            <span key={index}>
            <input 
              type="checkbox" 
              className="btn-check"
              id={`feedback_category_${category}`} 
              name="feedback_category"
              checked={formik.values.feedback_categories.includes(category)}
            />
            <label className="btn btn-outline btn-active-light-primary align-items-center mb-2 me-2 fs-7" onClick={() => handleCategoryChange(category)}>
              {intl.formatMessage({id: `chat.message.feedback.categories${['image','attribution'].includes(type) ? '_for_' + type : ''}.`+category})}
            </label>
            </span>
          ))}
          <textarea 
            className="form-control fs-7" 
            rows={1} 
            placeholder={intl.formatMessage({id: 'chat.message.feedback.comments'})} 
            {...formik.getFieldProps('feedback')}>
          </textarea>
        </div>
      </div>
      <div className="text-center">
        <button
            type='submit'
            className="btn btn-primary"
            disabled={handling || (formik.values.feedback_categories.length == 0 && formik.values.feedback.trim() == '')}
          >
          {!handling && <span className='indicator-label'>{intl.formatMessage({id: 'chat.message.feedback.submit'})}</span>}
          {handling && (
            <span className='indicator-progress' style={{display: 'block'}}>
              {intl.formatMessage({id: `general.please_wait`})}
              <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
            </span>
          )}
        </button>
      </div>
    </form>
  </Modal>
}
  
export {ChatResponseFeedbackModal}